module.exports = __webpack_public_path__ + "static/media/9.45d182f2.jpg";